<template>
  <div class="content-area">
    <nav class="graph-menu-area" >
      <ul class="graph-menu-tab">
        <li v-bind:class="{'active': this.mode == 0}"><a @click="modeChanged(0)">{{$t('app.dashboard.graph.latest')}}</a></li>
        <li v-bind:class="{'active': this.mode == 1}"><a @click="modeChanged(1)">{{$t('app.dashboard.graph.recently')}}</a></li>
        <li v-bind:class="{'active': this.mode == 2}"><a @click="modeChanged(2)">{{$t('app.dashboard.graph.span')}}</a></li>
      </ul>
    </nav>
    <DateTimePicker class="level-item" />
  </div>
</template>
<script>
import DateTimePicker from "./DateTimePicker"
import { mapState } from 'vuex';

export default {
  components: {
    DateTimePicker
  },
  computed: {
    ...mapState({
      mode: state => state.graph.options.pickstatus
    })
  },
  methods: {
    modeChanged(val) {
      this.mode = val;
      this.$store.dispatch("graph/setPickstatus", val);
    }
  }
};
</script>
<style>
.graph-menu-area {
  width: 100%;
  margin: 35px 0;
  background: #fff;
}
  .graph-menu-tab {
  display: flex;
}
.graph-menu-tab li {
  width: calc(100% / 3);
}
.graph-menu-tab li:nth-of-type(2) a {
  border-right: 2px solid #fff;
  border-left: 2px solid #fff;
}
.graph-menu-tab li a {
  display: block;
  width: 100%;
  padding: 15px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  letter-spacing: .05em;
  background: #ccc;
  color: #333;
}
.graph-menu-tab li.active a {
  background: #fff;
  font-weight: bold;
}
</style>
